<div class="p-6">
  <div class="flex items-center gap-3 mb-4">
    <div class="bg-amber-600 rounded-lg w-10 h-10 flex items-center justify-center flex-shrink-0">
      <mat-icon class="material-symbols-outlined !text-[22px] !w-[22px] !h-[22px] !leading-[22px] text-white">history</mat-icon>
    </div>
    <p class="text-white font-semibold text-lg m-0">
      {{ 'PACKAGES_PERSO_MANAGEMENT.DRAFT_RESTORE_TITLE' | translate }}
    </p>
  </div>

  <p class="text-gray-300 text-sm mb-3">
    {{ 'PACKAGES_PERSO_MANAGEMENT.DRAFT_RESTORE_DESCRIPTION' | translate }}
  </p>

  <div class="rounded-lg border border-gray-600 bg-black/20 px-4 py-3 mb-4">
    <span class="text-white text-sm">
      {{ 'PACKAGES_PERSO_MANAGEMENT.DRAFT_RESTORE_SAVED_AT' | translate:{ date: savedAt | date:'short' } }}
    </span>
  </div>

  @if (!hasFiles) {
    <p class="text-amber-300 text-xs mb-4">
      {{ 'PACKAGES_PERSO_MANAGEMENT.DRAFT_RESTORE_NO_FILES' | translate }}
    </p>
  }

  <div class="flex gap-3">
    <button type="button" (click)="onDiscard()"
      class="flex-1 px-4 py-3 rounded-lg border border-gray-500 text-white font-medium hover:bg-white/5 transition-colors">
      {{ 'PACKAGES_PERSO_MANAGEMENT.DRAFT_RESTORE_DISCARD' | translate }}
    </button>
    <button type="button" (click)="onRestore()" cdkFocusInitial
      class="flex-1 px-4 py-3 rounded-lg bg-rougeNovo text-white font-semibold hover:bg-rougeNovoHover transition-colors">
      {{ 'PACKAGES_PERSO_MANAGEMENT.DRAFT_RESTORE_CONFIRM' | translate }}
    </button>
  </div>
</div>
